export const downloadFile = (link: string) => {
  window?.open(link, '_blank')?.focus()
}
